import React from "react";
import { CloseIcon } from "app/components/Icons";
import DeleteIcon from "app/components/Icons/DeleteIcon";
import DownloadIcon from "app/components/Icons/DownloadIcon";
import OpenFileIcon from "app/components/Icons/OpenFileIcon";
import ShareIcon from "app/components/Icons/ShareIcon";
import CustomTooltip from "app/components/Tooltip";

type PreviewHeaderActionsProps = {
  onDownload?: () => void;
  onOpenFile?: () => void;
  onCopyUrl?: () => void;
  onDelete?: () => void;
  onClose?: () => void;
};

const PreviewHeaderActions: React.FC<PreviewHeaderActionsProps> = ({
  onDownload,
  onOpenFile,
  onCopyUrl,
  onDelete,
  onClose,
}) => {
  return (
    <div className="flex items-center gap-[10px] justify-end w-0 flex-1 max-w-[45%]">
      <CustomTooltip text="Download" position="bottom">
        <button
          type="button"
          onClick={onDownload}
          className="p-0.5 focus:outline-none disabled:opacity-50"
          disabled={!onDownload}
          aria-label="Download attachment"
        >
          <DownloadIcon size="24" color="#fff" />
        </button>
      </CustomTooltip>

      <CustomTooltip text="Open in a new tab" position="bottom">
        <button
          type="button"
          onClick={onOpenFile}
          className="p-0.5 focus:outline-none disabled:opacity-50"
          disabled={!onOpenFile}
          aria-label="Open attachment"
        >
          <OpenFileIcon size={20} color="#fff" />
        </button>
      </CustomTooltip>

      <CustomTooltip text="Copy URL" position="bottom">
        <button
          type="button"
          onClick={onCopyUrl}
          className="p-0.5 focus:outline-none disabled:opacity-50"
          disabled={!onCopyUrl}
          aria-label="Copy attachment URL"
        >
          <ShareIcon size="20" color="#fff" />
        </button>
      </CustomTooltip>

      {onDelete ? (
        <CustomTooltip text="Delete" position="bottom">
          <button
            type="button"
            onClick={onDelete}
            className="p-0.5 focus:outline-none"
            aria-label="Delete attachment"
          >
            <DeleteIcon size={20} color="#fff" />
          </button>
        </CustomTooltip>
      ) : null}

      <CustomTooltip text="Close" position="bottom">
        <button
          type="button"
          onClick={onClose}
          className="p-0.5 focus:outline-none disabled:opacity-50"
          disabled={!onClose}
          aria-label="Close preview"
        >
          <CloseIcon size="20" color="#fff" />
        </button>
      </CustomTooltip>
    </div>
  );
};

export default PreviewHeaderActions;
